import React from "react";
import { useLocation } from "react-router-dom";
import styled from "styled-components";
import colors from "../styles/colors";

const Label = styled.label`
  color: ${colors.grey3};
  font-size: 14px;
  font-weight: 400;
  font-weight:600;
  display: block;
  margin: ${(props) => props.marginTop || "10px"} 0
    ${(props) => props.marginBottom || "5px"} 0;
  text-transform: capitalize;
  @media screen and (max-width: 991px) {
    font-size: 13px;
  }

  @media screen and (max-width: 768px) {
    font-size: 12px;
  }
`;

const Header = styled.h3`
  font-size: 22px;
  margin-bottom: 20px;
  color: ${colors.seaGreen};
  @media screen and (max-width: 768px) {
    font-size: 18px;
    margin-bottom: 15px;
  }
`;

const HelpText = styled.p`
  font-size: 1.4rem;
  color: ${colors.grey3};
  margin: ${(props) => (props.top ? "0px 0px 20px 0px" : "0px 0px 20px 0px")};

  @media screen and (max-width: 768px) {
    font-size: 1.3rem;
    margin-bottom: 8px;
  }
`;

const contentToDisplay = {
    header: "Help Panel",
    content: [
      {
        type:"keyword",
        label: "KEYWORD",
        description: `Enter a short, catchy phrase that identifies your business. Your customers will be invited to text this phrase to a dedicated phone number to opt-in to receive your SMS Marketing campaigns. Example, "Love <Organization Name>" `,
      },
      {
        type:"selfOtpIn",
        label: "SELF OPT-IN TEXT MESSAGE",
        description: `Enter a phrase to auto populate a text message that your customers send to Check This Out when they scan the SMS self opt-in QR code. Example, "I would like to opt-in to receive SMS marketing updates from <Organization Name> about specials, events, gift card give-aways, and changes in service."`
      },
      {
        type:"optInGraphic",
        label: "DESCRIPTION ON SELF OPT-IN GRAPHIC",
        description: `Enter a phrase that will appear on the self opt-in graphic describing how your customer can self opt-in to receive your SMS marketing campaigns by scanning the QR code or texting a keyword. Example, "By scanning the QR code or texting the keyword you opt-in to receive SMS messages from <Organization Name> about special dishes, events, and other updates."`
      },
      {
        type:"enrollmentText",
        label: "SUCCESSFUL ENROLLMENT TEXT",
        description: `Enter a phrase that is automatically texted to your customers to confirm they have self opted-in through your QR code or keyword. Example, "Thank you for visiting us at <Organization Name> and for joining our VIP list. We'll keep you informed of our latest specials, events, and giveaways, and we promise to keep the texts enjoyable and to-the-point. We look forward to seeing you at <Organization Name> again soon!"`
      },
      {
        type:"includeReferralOptInText",
        label: "REFERRAL OPT-IN TEXT",
        description: `Referral marketing discounts, credit configurations, and uniquely identifiable referrer link will automatically be inserted at the end of the Successful Enrollment Text message.`
      },
    ],
};

const SidebarContent = ({sidebarType }) => {  
  const { header, content } = contentToDisplay;

  function replaceOrgName(originalText, orgName) {
    return originalText.replace(/<Organization Name>/g, orgName)
  };

  return (
    <>
      <Header>{header}</Header>
      {(() => {
        const matchedItem = content.find(item => item.type === sidebarType?.contentType);
        if (matchedItem) {
          return (
            <div key={matchedItem.type}>
              <Label>{matchedItem.label}</Label>
              <HelpText>{replaceOrgName(matchedItem.description, sidebarType?.orgName)}</HelpText>
            </div>
          );
        }
        return null;
        })()}
    </>
);

};

export default SidebarContent;

